const sliders = () => {
	if (document.querySelector('.js-orders-filters-slider')) {
		const slider = document.querySelector('.js-orders-filters-slider');

		const sliderConfig = new Swiper(slider, {
			slidesPerView: 'auto',
			spaceBetween: 8,
		})
	}

    if (document.querySelector('.js-promo-slider')) {
        const slider = document.querySelector('.js-promo-slider');

        const sliderConfig = new Swiper(slider, {
            spaceBetween: 16,
            enabled: false,
            breakpoints: {
                608: {
                    enabled: true,
                    slidesPerView: 2,
                },
                768: {
                    enabled: true,
                    slidesPerView: 3,
                },
                1024: {
                    enabled: true,
                    spaceBetween: 24,
                    slidesPerView: 4,
                }
            }
        })
    }

    if (document.querySelector('.js-header-stretch-slider')) {
        const slider = document.querySelector('.js-header-stretch-slider');

        const sliderConfig = new Swiper(slider, {
            autoHeight: true,
            autoplay: {
                delay: 10000,
            }
        })

        sliderConfig.on('transitionEnd', () => {
            document.dispatchEvent(new Event('header:update'));
        })
    }

    if (document.querySelector('.js-breadcrumbs')) {
        const slider = document.querySelector('.js-breadcrumbs');

        const sliderConfig = new Swiper(slider, {
            slidesPerView: 'auto',
        })
    }

    if (document.querySelector('.main-slider')) {
        const slider = document.querySelector('.main-slider');

        const sliderConfig = new Swiper(slider, {
            spaceBetween: 100,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        })

        $('.main-slider__slide-number-total').text(sliderConfig.slides.length || 0);

        sliderConfig.on('slideChange', () => {
            $('.main-slider__slide-number-current').text(sliderConfig.realIndex + 1);
        });
    }
}
